<template>
    <div class="slider__wrapper">
        <div class="wrapper">
            <div class="thumbnail-splide">
                <img  v-for="(image, index) in images" :src="src(thumbs[index] || image)" :alt="'Thumbnail ' + (index + 1)" loading="lazy" @click="handleThumbnailClick(index)"/>
            </div>
            <div class="slide-counter">
                {{ currentIndex }}/{{ images.length }}
            </div>
        </div>
        <Splide :options="mainOptions" :has-track="false" @splide:moved="handleMainSlideMoved"
        ref="mainSplide"     >
            <SplideTrack>
                <SplideSlide v-for="(image, index) in images" :key="index">
                    <img :src="src(image)"/>
                </SplideSlide>
            </SplideTrack>
            <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev">
                    <svg width="16.000000" height="16.000000" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <clipPath id="clip193_12796">
                                <rect id="Menu/Arrow/Right" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                            </clipPath>
                        </defs>
                        <rect id="Menu/Arrow/Right" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                        <g clip-path="url(#clip193_12796)">
                            <path id="Vector" d="M14 8L2 8" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.000000" stroke-linejoin="round" stroke-linecap="round"/>
                            <path id="Vector" d="M10 4L14 8L10 12" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.000000" stroke-linejoin="round" stroke-linecap="round"/>
                        </g>
                    </svg>
                </button>
                <button class="splide__arrow splide__arrow--next">
                    <svg width="16.000000" height="16.000000" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <defs>
                            <clipPath id="clip193_12796">
                                <rect id="Menu/Arrow/Right" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
                            </clipPath>
                        </defs>
                        <rect id="Menu/Arrow/Right" rx="0.000000" width="15.000000" height="15.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
                        <g clip-path="url(#clip193_12796)">
                            <path id="Vector" d="M14 8L2 8" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.000000" stroke-linejoin="round" stroke-linecap="round"/>
                            <path id="Vector" d="M10 4L14 8L10 12" stroke="#131A29" stroke-opacity="1.000000" stroke-width="1.000000" stroke-linejoin="round" stroke-linecap="round"/>
                        </g>
                    </svg>

                </button>
            </div>
        </Splide>   
    </div>
  </template>
  
<script>
    import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
    import "@splidejs/splide/dist/css/splide.min.css";
    
    export default {
        components: {
        Splide,
        SplideSlide,
        SplideTrack
        },
        props: {
            images: [Array, Object],
            thumbs: {
                type: Array,
                default: () => [],
            },
        },
        data() {
        return {
            currentIndex: 1,
            mainOptions: {
                type  : 'fade',
                rewind: true,
                padding: '0px',
                perPage: 1,
                perMove: 1,
                gap: 24,
                padding: 0,
                autoHeight: true,
                arrows: true,
                pagination: false,
                breakpoints: {
                        768: {
                            perPage: 1,
                        },
                    }
            },
        };
        },
        methods: {
            src(image) {
                // Внешние картинки (UGM) приходят полным URL
                return /^https?:\/\//.test(image) ? image : `${this.$store.state.base_directory}${image.replace(/^public\//, '')}`;
            },
            handleThumbnailClick(index){
                const mainSlider = this.$refs.mainSplide.splide;
                mainSlider.go(index);
                this.currentIndex = index + 1;
            },
            handleMainSlideMoved() {
            this.currentIndex = this.$refs.mainSplide.splide.index + 1;
            },
        },
    };
</script>
  
  <style scoped>
  .wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .splide__arrow--prev {
    left: 0px;
    bottom: 0px;
    top: calc(100% - 16px);
    }

    .splide__arrow--next {
        right: 0px;
        bottom: 0px;
        top: calc(100% - 16px);
    }

    .splide__arrow--prev svg {
        transform: rotate(180deg);
    }

    .splide__arrow:disabled {
        visibility: hidden;
        opacity: 0;
    }

    .splide__arrow {
        transition: all 0.1s;
        width: 32px;
        height: 32px;
        border-radius: 32px;
        background: rgb(222, 230, 234);
    }
.splide__arrow:hover svg{
    fill: unset;
}
  .splide__arrows{
    display: block !important;
  }
  .slide-counter{
    display: flex;
    justify-content: center;
    /* Header/H4: 16px Medium */
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: left;
    padding-top: 29px;
    padding-right: 16px;
  }
  .thumbnail-splide{
    width: 94px;
    min-width: 94px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    max-height: 600px;
    padding-right: 16px;
  }
  .thumbnail-splide::-webkit-scrollbar {
  width: 2px !important;
  border-radius: 32px !important;
}

.thumbnail-splide::-webkit-scrollbar-thumb {
  background: rgb(222, 230, 234) !important;
  border-radius: 32px !important;
}

.thumbnail-splide::-webkit-scrollbar-track {
  background: transparent !important;
}
  .thumbnail-splide img{
    width: 100%;
    height: 103px;
    min-height: 103px;
    object-fit: cover;
  }
  .splide__slide img{
    width: 100%;
    height: 646px;
    object-fit: cover;
    }
  .slider__wrapper{
    display: flex;
    gap: 42px;
    width: 100%;
  }
  .splide{
    padding: 0;
    padding-bottom: 32px;
  }
  .rounded {
    border-radius: 8px;
  }
@media (max-width: 1320px) {
    .slider__wrapper {
        gap: 20px;
    }
} 
@media (max-width: 1024px) {
    .splide__slide img{
        max-height: 400px;
    }
    .splide{
        width: 100%;
    }
}
@media (max-width: 768px) {
    .slider__wrapper{
        flex-direction: column;
    }
    .splide__slide img{
        height: unset;
        max-height: unset;
    }
    .wrapper{
        order: 2;
    }
    .thumbnail-splide {
        width: 100%;
        min-width: 94px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        overflow-y: unset;
        overflow-x: auto;
        max-height: 600px;
        padding-right: unset;
    }
    .slide-counter {
        text-align: left;
        padding-top: 16px;
        padding-right: unset;

    }
    .splide__arrow--prev {
    left: 10px;
    bottom: unset;
    top: 50%;
    }

    .splide__arrow--next {
        right: 10px;
        bottom: unset;
        top: 50%;
    }
    .splide{
        padding-bottom: unset;
    } 
    .thumbnail-splide img {
        width: 100%;
        min-width: 150px;
        height: 103px;
        min-height: 103px;
    }
}
  </style>
  